// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T5CD","actions":"styles_actions__1F69L","error":"styles_error__1nNI8","message":"styles_message__1FXEf"};